
export class CreateLinkPaypalPlanModal{

    constructor(
      private   hospitalName:string,
      private   saName:string,
      private   trialValue:number,
      private   fixedValue:number
    ){

    }
}